export default "__VITE_ASSET__Hscempp2__"